import React from 'react';

import { CopyToClipboard } from 'react-copy-to-clipboard';

import { Row, Col, Button } from 'react-bootstrap';

type Props = {
  texto: string;
};

const CopiarAreaTrabalho: React.FC<Props> = ({ texto }) => {
  return (
    <>
      <Row noGutters>
        <Col className="mb-1">
          <span>
            <b>Link para pagamento:</b>
          </span>
        </Col>
      </Row>
      <Row noGutters>
        <Col className="mb-1">
          <span>{`${texto}`}</span>
        </Col>
      </Row>
      <Row noGutters>
        <Col>
          <CopyToClipboard text={texto || ''}>
            <Button type="button" variant="info" size="sm">
              Copiar
            </Button>
          </CopyToClipboard>
        </Col>
      </Row>
    </>
  );
};

export default CopiarAreaTrabalho;
